export default "__VITE_ASSET__DlnhFmLk__"